/*
 * @Description: 页面说明 公用方法
 * @Version: 版本号
 * @Author: chuzhangyi
 * @Date: 2022-06-28 13:43:38
 * @LastEditors: 最后一次编辑说明
 * @LastEditTime: 2024-01-16 09:42:18
 * @FilePath: \admine:\LBB\wechat_business\src\utils\index.js
 */
function download(href, name) {
  let eleLink = document.createElement('a')
  eleLink.download = name
  eleLink.href = href
  eleLink.click()
  eleLink.remove()
}

// 下载图片
export const downloadImg = (url, name = new Date().toLocaleString()) => {
  let image = new Image()
  image.setAttribute('crossOrigin', 'anonymous')
  image.src = url
  image.onload = () => {
    let canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    let ctx = canvas.getContext('2d')
    ctx.drawImage(image, 0, 0, image.width, image.height)
    canvas.toBlob((blob) => {
      let url = URL.createObjectURL(blob)
      download(url, name)
      // 用完释放URL对象
      URL.revokeObjectURL(url)
    })
  }
}

// 金额格式化千分符 s:金额； n:小数点位数 最大5位
export const formatMoney = (s, n = 2) => {
  s = s || 0;
  let num1 = s.toString().split('.')[1]
  n = n || 2
  if (num1) {
    n = num1.length
  }
  s = s.toString();
  s = parseFloat(s.replace(/[^\d\.-]/g, "")).toFixed(n);
  s = s.toString().split('.');
  s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return s.join('.')
}

// 正多位小数 默认2位(用于限制输入最多len位小数的input)
export function formatterTowDecimal(value, len = 2) {
  if (value) {
    let reg = new RegExp(`^\\D*(\\d*(?:\\.\\d{0,${len}})?).*$`, 'g');
    value = value.replace(reg, '$1');
    if (len == 0) {
      value = parseInt(value).toString()
    }
  }
  return value;
}

//手机号
export function isMobile(val) {
  val = String(val)
  return /^1[3456789]\d{9}$/.test(val);
}

// 调用拨号功能
export function callPhone(phoneNumber) {
  window.location.href = 'tel://' + phoneNumber
}

//复制
export function copyText(value) {
  var textArea = document.createElement("textarea");
  textArea.style.background = 'transparent';
  textArea.style.position = 'fixed';
  textArea.style.left = '-100vw';

  textArea.value = value;
  document.body.appendChild(textArea);
  textArea.select();
  try {
    var successful = document.execCommand('copy');
    this.$toast(`复制完成`);
  } catch (err) {
    console.log('Oops, unable to copy');
  }
  document.body.removeChild(textArea);
}

// 复制   需要复制的dom  可设置不可选中  去除不需要选中 的文本 （user-select: none;）
export function copyTextOfDom(el) {
  try {
    // 选中dom中的文本
    if (document.body.createTextRange) { //IE浏览器
      var range = document.body.createTextRange(); //创建选区
      range.moveToElementText(el); //移动TextRange对象使其起始点之间包含指定对象内的文本
      range.select(); //选中选区
      document.execCommand("copy");
      document.selection.empty();
      // 或使用 clear() 方法
      document.selection.clear();
    } else if (window.getSelection) { //非IE浏览器，getSelection方法可以产生Selection对象，所对应的是用户所选择的 ranges （区域），俗称拖蓝。
      var selection = window.getSelection();
      selection.removeAllRanges(); //将所有的区域都从选区中移除
      var range = document.createRange(); //返回新创建的 Range 对象，两个边界点都被设置为文档的开头
      range.selectNodeContents(el); //把范围边界设置为一个节点的子节点
      selection.addRange(range); //将一个区域（Range）对象加入选区
      document.execCommand("copy");
      selection.removeAllRanges();
    }
    this.$toast(`复制完成`);
  } catch (error) {
    console.log('复制失败', error);
  }
}

// 获取连接后参数
export function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const search = decodeURI((window.location.search || window.location.hash)).split('?')[1] || '';
  // log('getQueryString', search)
  const r = search.match(reg) || [];
  return r[2];
}

// 是否是微信浏览器
export function isWeiXin() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.match(/microMessenger/i) == 'micromessenger'
}

// 是否在微信小程序 web-view 内
export function isMiniProgram() {
  if (window.__wxjs_environment === 'miniprogram') return true
  return /miniProgram/i.test(navigator.userAgent.toLowerCase())
}

// 是否是企业微信浏览器
export function isWxWork() {
  const ua = navigator.userAgent.toLowerCase();
  return /wxwork/i.test(ua)
}

// 是否是手机端
export function isDeviceMobile() {
  const ua = navigator.userAgent.toLowerCase();
  return /android|webos|iphone|ipod|balckberry/i.test(ua)
}

// 去除字符串空格 （type）  all：全部 front:前 after：后 bothEnds：两头
export function trim(str = '', type = 'all') {
  if (type == 'all') {
    str = str.replace(/\s+/g, "");
  } else if (type == 'front') {
    str = str.replace(/^\s*/g, '');
  } else if (type == 'after') {
    str = str.replace(/(\s*$)/g, "");
  } else if (type == 'bothEnds') {
    str = str.replace(/^\s+|\s+$/g, "");
  }
  return str;
}

export function getDateStr(time) {
  const fix0 = num => num > 9 ? `${num}` : `0${num}`
  const _time = time ? new Date(time) : new Date()
  const _y = _time.getFullYear()
  const _m = _time.getMonth() + 1
  const _d = _time.getDate()
  return `${_y}-${fix0(_m)}-${fix0(_d)}`
}

export function getNextDateStr(days, startDate) {
  const fix0 = num => num > 9 ? `${num}` : `0${num}`
  const startTime = startDate ? new Date(startDate).getTime() : new Date().getTime()
  const _days = days || days === 0 ? days : 1
  const _time = new Date(startTime + _days * 86400000)
  const _year = _time.getFullYear()
  const _month = _time.getMonth() + 1
  const _date = _time.getDate()
  return `${_year}-${fix0(_month)}-${fix0(_date)}`
}

/**
 * @Description: 时间格式化
 * @param {type} fmt  时间格式 yyyy-MM-dd HH:mm:ss/yyyy-MM-dd
 * @param {type} val 时间轴
 */
export function formatDate(fmt, val) {
  let date = val ? (new Date(val)) : (new Date());
  if (date == 'Invalid Date') {
    date = val ? (new Date(val.replace(/[.-]/g, '/'))) : (new Date());
    if (date == 'Invalid Date') {
      date = new Date();
    }
  }
  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "H+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

/**
 * 小数输入限制
 * @param {string} str 输入值
 * @param {number} num 保留位数
 * @returns
 */
export function numPoint(str, num = 2) {
  str = str.replace(/[^\d.]/g, "");
  str = str.replace(/\.{2,}/g, ".");
  str = str.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  if (num == 0) {
    str = str.replace(/[^\d]/g, "");
  } else if (num == 1) {
    str = str.replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3");
  } else if (num == 2) {
    str = str.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
  } else if (num == 3) {
    str = str.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3");
  } else if (num == 4) {
    str = str.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, "$1$2.$3");
  } else if (num == 5) {
    str = str.replace(/^(\-)*(\d+)\.(\d\d\d\d\d).*$/, "$1$2.$3");
  } else if (num == 6) {
    str = str.replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, "$1$2.$3");
  } else if (num == 7) {
    str = str.replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d\d).*$/, "$1$2.$3");
  } else {
    if (str.indexOf(".") > -1) {
      const integerPart = str.split('.')[0];
      const decimalPart = str.split('.')[1].slice(0, num);
      str = `${integerPart}.${decimalPart}`;
    }
  }
  if (str.indexOf(".") < 0 && str != "") {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    str = parseFloat(str);
  }
  return str;
}

export function numPoint2(str, num = 2) {
  str = str.replace(/[^\d.]/g, "");
  str = str.replace(/\.{2,}/g, ".");
  str = str.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  if (num == 1) {
    str = str.replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3");
  } else if (num == 2) {
    str = str.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
  } else if (num == 3) {
    str = str.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3");
  } else if (num == 4) {
    str = str.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, "$1$2.$3");
  } else if (num == 5) {
    str = str.replace(/^(\-)*(\d+)\.(\d\d\d\d\d).*$/, "$1$2.$3");
  } else if (num == 6) {
    str = str.replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, "$1$2.$3");
  } else if (num == 7) {
    str = str.replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d\d).*$/, "$1$2.$3");
  }
  return str;
}
